<template>
    <div id="main-wrapper">
        <div class="content-wrapper">
            <slot />
        </div>
        <div class="footer-wrapper">
            <GlobalFooter />
        </div>
    </div>
</template>

<style lang="scss">
    #main-wrapper {
        display: flex;
        min-height: 100vh;
        flex-direction: column;   
        padding-top: 55px;
        width: 100vw;

        .content-wrapper {
            flex: 1 0 auto;
        }

        .footer-wrapper {
            flex-shrink: 0;
        }

        @media (min-width: $mobile) {
            padding-top: 88px;
        }
        
        [class*='builder-pixel'] {
            position: absolute;
        }
    }
</style>